import React from 'react';
import InvalidIcon from '@atlaskit/icon/glyph/jira/failed-build-status';
import { CheckboxOption } from '@atlaskit/select';
import { R400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { StyledInvalidCheckboxOption } from '../../../../common/ui/picker/styled';
export var Option = function Option(props) {
  var _props$data;

  if ((_props$data = props.data) !== null && _props$data !== void 0 && _props$data.invalid) {
    return /*#__PURE__*/React.createElement(StyledInvalidCheckboxOption, null, /*#__PURE__*/React.createElement(CheckboxOption, props), /*#__PURE__*/React.createElement(Tooltip, {
      content: props.selectProps.fieldInvalidLabel
    }, /*#__PURE__*/React.createElement(InvalidIcon, {
      label: "Test",
      primaryColor: token('color.icon.danger', R400)
    })));
  }

  return /*#__PURE__*/React.createElement(CheckboxOption, props);
};